import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class MITPService {
	Calc(): string {
		return `${environment.baseUrl}/calcs`;
	}

	Catalog(): string {
		return `${environment.baseUrl}/catalog`;
	}

	Contact(): string {
		return `${environment.baseUrl}/contacts`;
	}

	Dashboard(): string {
		return `${environment.baseUrl}/dashboard`;
	}

	Department(): string {
		return `${environment.baseUrl}/departments`;
	}

	Directory(): string {
		return `${environment.baseUrl}/directories`;
	}

	Drugs(): string {
		return `${environment.baseUrl}/drugs`;
	}

	EmailDeliveries(): string {
		return `${environment.baseUrl}/email-deliveries`;
	}

	Encounters(): string {
		return `${environment.baseUrl}/encounters`;
	}

	Education(): string {
		return `${environment.baseUrl}/education`;
	}

	Guidelines(): string {
		return `${environment.baseUrl}/guidelines`;
	}

	Icons(): string {
		return `${environment.baseUrl}/icons`;
	}

	Institutes(): string {
		return `${environment.baseUrl}/institutes`;
	}

	Janus(): string {
		return `${environment.baseUrl}/janus`;
	}

	Jobs(): string {
		return `${environment.baseUrl}/jobs`;
	}

	Knowledge(): string {
		return `${environment.baseUrl}/knowledge`;
	}

	Legal(): string {
		return `${environment.baseUrl}/legal`;
	}

	Login(): string {
		return `${environment.baseUrl}/login`;
	}

	MedicalScales(): string {
		return `${environment.baseUrl}/tools/medical-scales`;
	}

	MedicalTools(): string {
		return `${environment.baseUrl}/tools/medical-tools`;
	}

	Notifications(): string {
		return `${environment.baseUrl}/notifications`;
	}

	Packages(): string {
		return `${environment.baseUrl}/packages`;
	}

	Pathways(): string {
		return `${environment.baseUrl}/pathways`;
	}

	PatientPortal(): string {
		return `${environment.baseUrl}/patient-portal`;
	}

	Patients(): string {
		return `${environment.baseUrl}/patients`;
	}

	Pharmacy(): string {
		return `${environment.baseUrl}/pharmacy`;
	}

	ProSanteConnect(): string {
		return `${environment.baseUrl}/auth/psc`;
	}

	ProtocolNotebooks(): string {
		return `${environment.baseUrl}/protocol-notebooks`;
	}

	ProtocolNotes(): string {
		return `${environment.baseUrl}/protocol-notes`;
	}

	ProtocolUpdates(): string {
		return `${environment.baseUrl}/protocol-updates`;
	}

	Protocols(): string {
		return `${environment.baseUrl}/protocols`;
	}

	ProtocolVisibilityRules(): string {
		return `${environment.baseUrl}/protocols/visibility-rules`;
	}

	PublicProtocols(): string {
		return `${environment.baseUrl}/public/protocols`;
	}

	PublicResources(): string {
		return `${environment.baseUrl}/public/resources`;
	}

	Quality(): string {
		return `${environment.baseUrl}/quality`;
	}

	Scores(): string {
		return `${environment.baseUrl}/tools/scores`;
	}

	Server(): string {
		return `${environment.baseUrl}/server`;
	}

	Signup(): string {
		return `${environment.baseUrl}/signup`;
	}

	Statistics(): string {
		return `${environment.baseUrl}/statistics`;
	}

	Status(): string {
		return `${environment.baseUrl}/status`;
	}

	Store(): string {
		return `${environment.baseUrl}/store`;
	}

	Subscriptions(): string {
		return `${environment.baseUrl}/subscriptions`;
	}

	Tags(): string {
		return `${environment.baseUrl}/tags`;
	}

	Tools(): string {
		return `${environment.baseUrl}/tools`;
	}

	Users(): string {
		return `${environment.baseUrl}/users`;
	}

	Videos(): string {
		return `${environment.baseUrl}/videos`;
	}

	Workflows(): string {
		return `${environment.baseUrl}/workflows`;
	}
}
